import { onboardingGetStartedSteps } from "@domain/onboarding/onboarding";

export const getStartedSteps = onboardingGetStartedSteps;

export enum GetStartedStepStatus {
	Default = "Default",
	Completed = "Completed",
	Disabled = "Disabled",
}
